<template>
    <div class="details">
        <my-header></my-header>
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" ><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <el-row :span="24" class="msg">
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <div :span="4" class="hidden-xs-only">
                    <div class="detail_left" >
                        <ul>
                            <span><i class="el-icon-s-custom"></i> 服务中心</span>
                            <li v-for="(list,index) in rightList"  :key="index" @click="change(index)" :class="{active : changes == index}" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)"><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                        </ul>
                    </div>
                </div>
                <el-col v-if="showSee" >
                    <div class="md_fwzx">
                        <ul>
                            <span><i class="el-icon-s-custom"></i>服务中心</span>
                            <li v-for="(list,index) in rightList" :key="index" @click="change(index)" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)"><i class="el-icon-remove-outline"></i>{{list.text}}</li>
                        </ul>
                    </div>
                    
                </el-col>
                <div :span="12" :xs="{span:16}" :sm="{span:16}" :md="{span:16}">
                    <div class="detail_right">
                        <div class="minute" >
                            <span> <i class="el-icon-s-unfold"></i> 详细内容</span>
                            <ul>
                                <li class="min_title">{{detail.title}}</li>
                                <li class="min_time"> <strong>发布时间:</strong> {{detail.addtime}}</li>
                                <li class="min_msg" v-html="detail.content">{{detail.content}}</li>
                            </ul>
                        </div>
                        <div style="clear:both"></div>
                        <div >
                            <ul  >
                                <li v-for="(list,m) in detail.annexes" :key="m" @click="download(list.url)" style="float:left;margin-top:10px;margin-right:20px;font-size:16px;border-bottom:1px solid blue;color:blue;">{{list.name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <my-footer></my-footer>
    </div>
</template>
<script>

import MyHeader  from '../headerPage'
import MyFooter from '../footerPage'
export default {
    components:{ MyHeader,MyFooter},
    data() {
        return {
            changeRed:0,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
            rightList:[{
                text:'法律事务'
            },{
                text:"物流服务"
            },{
                text:"融资投资"
            },{
                text:"租赁共享"
            },{
                text:"峰会展览"
            },{
                text:"商务考察"
            },{
                text:"翻译公证"
            },{
                text:"人才交流"
            },{
                text:"慈善文化"
            },{
                text:"互助基金"
            },{
                text:"财务管理"
            },{
                text:"政策宣传"
            },{
                text:"投融资项目公示"
            }],
            detail:{},
            changes:0,
            showSee:false,
        }
    },
    mounted() {
        window.scrollTo(0,0);
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showSee = true
        }else{
            this.showSee = false
        }
        this.detailFun();
        this.changesActive(); 
    },
    updated() {
        let DomList=document.getElementsByClassName('min_msg')[0].querySelectorAll('img');
        for(let i in  DomList){
            if( DomList[i].style){
                DomList[i].style.width='50%'
                DomList[i].style.height='50%'
            }
        }
    },
    methods:{
        changesActive(){
            ///判断文章 类别
            if(this.detail.type == 'LAW'){
                this.changes = 0
            }else if(this.detail.type=='LOGISTICS'){
                this.changes = 1
            }else if(this.detail.type=='FINANCE'){
                this.changes = 2 
            }else if(this.detail.type=='LEASE'){
                this.changes = 3
            }else if(this.detail.type=='EXHIBTION'){
                this.changes = 4
            }else if(this.detail.type=='BUSINESS'){
                this.changes = 5
            }else if(this.detail.type=='TRANSLATE'){
                this.changes = 6
            }else if(this.detail.type=='TALENT'){
                this.changes = 7
            }else if(this.detail.type=='CHARITABLE'){
                this.changes = 8
            }else if(this.detail.type=='FOUNDATION'){
                this.changes = 9
            }else if(this.detail.type=='AFFAIRS'){
                this.changes = 10
            }else if(this.detail.type=='POLICY'){
                this.changes = 11
            }else if(this.detail.type=='PROJECTSHOW'){
                this.changes = 12
            };
        },
        //移入事件
        changeActive($event){
            $event.currentTarget.className="active"
        },
        //移出
        removeActive($event){
             $event.currentTarget.className="";
        },
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
        change(index){
            this.$router.push({ name: 'levalPage',params:{changes:index+1}})
            this.changes = index;
        },
        detailFun(){
            this.detail = this.$route.query.art;
        },
        download(url){
            window.open(url);
        }
    }
}
</script>
<style scoped >
.msg{
    margin-top:40px;
}
    .detail_left{
        float: left;
        width:16%;
        height:auto;
    }
    .detail_left ul{
        width: 100%;
        height:auto;
        border:1px solid #cecece;
    }
    .detail_left ul span{
        display:block;
        width:100%;
        height:auto;
        min-height:46px;
        font-size:20px;
        text-align:center;
        line-height:46px;
        color:#fff;
        background-color: #1f3358;
    }
    .detail_left ul li{
        width:90%;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px auto;
        border-radius: 6px;
        color:#1e3557;
        cursor:pointer;
        background-color: #ededed;
    }
    .detail_left ul li i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 10px 0 20px;
    }
    .detail_left ul li.active{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    .md_fwzx{
        width:100%;
        height:auto;
    }
    .md_fwzx ul{
        float: left;
        /* width:100%; */
        margin:0 auto;
        border:1px solid #ececec;
    }
    .md_fwzx ul span{
        display:block;
        width:100%;
        font-size:20px;
        text-align: center;
        line-height:46px;
        color:#fff;
        background-color: #1e3557;
    }
     .md_fwzx ul li{
        float: left;
        height:40px;
        text-align: left;
        line-height:40px;
        margin:22px 10px;
        border-radius: 6px;
        color:#1e3557;
        box-sizing: border-box;
        padding:0 10px;
        cursor:pointer;
        background-color: #ededed;
    }
    .md_fwzx ul i{
        color:#d3d3d3;
        box-sizing: border-box;
        padding:0 4px 0 4px;
    }
    .md_fwzx ul li.Act{
        background-color: #FE9900;
        color:#fff;
    }
    /* 手机端 服务中心 在底部 */
    .detail_right{
        float:left;
        width:82%;
        margin-left:20px;
        
    }
    .detail_right .minute{
        width:100%;
        height:auto;
        min-height:500px;
        border: 1px solid #999;
    }
    .minute span{
        display:block;
        width: 100%;
        height:auto;
        min-height:46px;
        font-size:20px;
        line-height:46px;
        box-sizing: border-box;
        padding:0 14px;
        color:#fff;
        background-color: #1f3358;
    }
    .minute ul{
        text-align: center;
    }
    
    .minute ul .min_title{
        width: 90%;
        min-height:100px;
        line-height:100px;
        font-size:24px;
        font-weight:600;
        color:#333;
        margin:0 auto;
        border-bottom:1px solid #999;
    }
    .minute ul .min_time{
        width: 90%;
        line-height:40px;
        margin:0 auto;
        color:#999;
        border-bottom:1px solid #999;
    }
    .minute ul .min_msg{
        width: 90%;
        margin:10px auto;
        font-size:20px;
        color:#666;
        text-align: justify;
    }
     .min_msg img{
        display:none;
        width:200px;
        height:200px;
    }
    /* Daohang */
    .bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }
</style>


// WEBPACK FOOTER //
// src/components/ZH-CN/detailsPage.vue